import { Button, Icon } from '@zillow/constellation-10';
import { IconReloadFilled } from '@zillow/constellation-icons';

type Props = {
  ariaLabel: string;
  onRevert: () => void;
};

const RevertButton = ({ ariaLabel, onRevert }: Props) => (
  <Button
    aria-label={ariaLabel}
    emphasis="outlined"
    size="sm"
    tone="brand"
    icon={<Icon render={<IconReloadFilled />} />}
    onClick={onRevert}
  >
    Revert
  </Button>
);

export default RevertButton;
